<template>
  <v-col>
    <v-card>
      <v-card-title class="pb-8">
        <v-btn
          color="primary"
          @click="CHANGE_RIPARAZIONI_CLIENTI_COMPONENT('Insert')"
        >Nuova Riparazione</v-btn>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Cerca"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="riparazioni"
        class="elevation-1"
        :search="search"
        :items-per-page="100"
        :footer-props="{
      itemsPerPageAllText: 'Tutti',
      itemsPerPageOptions: [15, 50, 100, -1],
      itemsPerPageText: 'Riparazioni per pagina',
    }"
      >
        <template v-slot:top>
          <edit-form
            :item="selectedItem"
            @edit-submit="triggerSnack($event)"
          />
        </template>

        <template v-slot:item.is_retired="{ item }">
          <v-icon
            color="red"
            v-if="item.is_retired === 0"
          >
            mdi-close
          </v-icon>
          <v-icon
            color="green"
            v-else
          >
            mdi-check
          </v-icon>
        </template>

        <template v-slot:no-data>
          <v-btn
            color="primary"
            @click="fetchRiparazioni"
          >Ricarica</v-btn>
        </template>

        <template v-slot:item.created_at="{ item }">
          <span>{{new Date(item.created_at).toLocaleString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' })}}</span>
        </template>

        <template v-slot:item.customer="{ item }">
          <span>{{item.name}} {{item.surename}}</span>
        </template>

        <template v-slot:item.cost="{ item }">
          <span>{{item.cost || '0'}}€</span>
        </template>

        <template v-slot:item.price="{ item }">
          <span>{{item.price || '0'}}€</span>
        </template>

        <template v-slot:item.action="{ item }">
          <td class="actions">
            <v-btn
              color="orange"
              elevation="1"
              outlined
              small
              @click.stop="edit(item)"
            >
              <v-icon small>
                mdi-pencil
              </v-icon>
            </v-btn>
            <v-btn
              color="red"
              elevation="1"
              outlined
              small
              @click.stop="triggerDialog(item)"
            >
              <v-icon small>
                mdi-delete
              </v-icon>
            </v-btn>
          </td>
        </template>
        <snack-notification :snack="snack" />
      </v-data-table>
    </v-card>

    <!-- dialog -->
    <v-row justify="center">
      <v-dialog
        v-model="dialog"
        max-width="350"
      >
        <v-card>
          <v-card-title class="headline">Cancellare riparazione?</v-card-title>

          <v-card-text>
            Confermando, la riparazione verrà eliminata dal database e le compnenti utilizzate reinserite nel magazzino. <br><br> Se presente un'operazione di vendita collegata alla riparazione, anche questa verrà eliminata.
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="primary"
              text
              @click="remove"
            >
              Conferma
            </v-btn>

            <v-btn
              color="primary"
              @click="dialog = false"
            >
              Annulla
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-col>
</template>

<script>
  import axios from 'axios'
  import { mapMutations } from 'vuex'

  import EditForm from './EditForm'
  import SnackNotification from './../../SnackNotification'

  export default {
    name: 'Index',
    components: {
      EditForm,
      SnackNotification
    },
    data: () => ({
      search: '',
      dialog: false,
      headers: [
        { text: 'Ritirato', value: 'is_retired', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Data', value: 'created_at', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'IMEI', value: 'serial', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Brand', value: 'brand', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Modello', value: 'model', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Colore', value: 'color', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Prezzo', value: 'price', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Cliente', value: 'customer', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Telefono', value: 'phone', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Nota Pubblica', value: 'public_note', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Nota Privata', value: 'private_note', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: '', value: 'action', class: 'subtitle-2 primary--text font-weight-bold', sortable: 'false' }
      ],
      riparazioni: [],
      item: {},
      snack: {
        error: null,
        visible: null,
        message: null
      },
      config: {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
        }
      }
    }),

    computed: {
      selectedItem() {
        return this.item
      }
    },

    methods: {
      ...mapMutations([
        'CHANGE_RIPARAZIONI_CLIENTI_COMPONENT',
        'CHANGE_RIPARAZIONI_CLIENTI_EDIT'
      ]),

      async fetchRiparazioni() {
        try {

          let {
            data
          } = await axios.get(`${process.env.VUE_APP_API}/repairs/customer/fetch`, this.config)

          this.riparazioni = data
        } catch (error) {

          console.log(error)

          this.riparazioni = []
        }
      },

      edit(val) {
        this.item = val
        this.CHANGE_RIPARAZIONI_CLIENTI_EDIT(true)
      },

      async remove() {
        console.log('item', this.item)

        const { data } = await axios.post(`${process.env.VUE_APP_API}/v2/repairs/customer/delete`, { id: this.item.id }, this.config)

        if (data.status) {
          this.fetchRiparazioni()
          this.dialog = false
        } else {
          alert('Si è verificato un errore.')
        }
      },


      triggerDialog(val) {
        this.item = val
        this.dialog = true
      },

      triggerSnack(e) {
        if (e === 'reset') {

          this.snack = Object.assign({}, {
            error: null,
            visible: null,
            message: null
          })
        } else if (e === 'ok') {

          this.snack = Object.assign({}, {
            visible: true,
            error: false,
            message: 'Riparazione modificato correttamente!'
          })

          this.fetchRiparazioni()
        } else if (e === 'error') {

          this.snack = Object.assign({}, {
            visible: true,
            error: true,
            message: 'Errore nella modifica.'
          })
        }
      }
    },

    async created() {
      await this.fetchRiparazioni()
    },
  }
</script>

<style scoped>
  .actions {
    display: flex;
    flex-flow: row;
    justify-content: flex-end;
    align-items: center;
  }

  .actions > button {
    margin-left: 10px;
  }
</style>